<template>
  <div class="info-overlay">
    <h3 v-if="payload.title" class="info-overlay__title">{{ payload.title }}</h3>
    <p v-if="payload.message" class="info-overlay__message">{{ payload.message }}</p>
  </div>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  payload: {
    type: Object as PropType<Record<string, unknown>>,
    default: () => ({}),
  },
})
</script>

<style scoped lang="scss">
.info-overlay {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__title {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }

  &__message {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);
  }
}

// Light theme adjustments
[data-vp-theme='light'] .info-overlay {
  &__title {
    color: #000000;
  }

  &__message {
    color: rgba(0, 0, 0, 0.7);
  }
}
</style>
